import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationChangeService {
  private translationChanged$ = new Subject<string>();

  /**
   * Observable that emits whenever the language/translations change
   */
  getTranslationChanges() {
    return this.translationChanged$.asObservable();
  }

  /**
   * Call this method after translations are initialized to notify all subscribers
   */
  notifyTranslationChange(languageCode: string): void {
    this.translationChanged$.next(languageCode);
  }
}
